import { toast } from 'react-hot-toast';
import errorMessage from '../helper/error-message';
import axios from 'axios';

export interface PaginatedResponse<T> {
  message: string;
  data: T[];
  currentPage: number;
  totalPages: number;
  totalItems: number;
}

export interface ErrorLog {
  id: string;
  message: string;
  payload: string;
  createdAt: string;
  updatedAt: string;
  version: number;
}

export interface ChangeLog {
  id: string;
  username: string;
  ChangeLog: string;
  createdAt: string;
  updatedAt: string;
  version: number;
}

export const fetchErrorLogs = async (page: number = 1): Promise<PaginatedResponse<ErrorLog>> => {
  try {
    const response = await axios.get(`/api/cms/get-error-message?page=${page}}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching error logs:', error);
    return { message: '', data: [], currentPage: 1, totalPages: 0, totalItems: 0 };
  }
};

export const fetchChangeLogs = async (page: number = 1): Promise<PaginatedResponse<ChangeLog>> => {
  try {
    const response = await axios.get(`/api/cms/get-changelog-message?page=${page}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching change logs:', error);
    return { message: '', data: [], currentPage: 1, totalPages: 0, totalItems: 0 };
  }
};

export const deleteErrorLogs = async (): Promise<boolean> => {
  try {
    const response = await fetch(`/api/cms/delete-error-message`, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    const res = await response.json();
    if (!response.ok) throw new Error(res.errors?.[0]?.message || res.message || 'Failed to delete error logs');
    toast.success('Semua error log berhasil dihapus');
    return true;
  } catch (error: any) {
    toast.error(error.message || `Terjadi kesalahan ketika menghapus logs.`);
    return false;
  }
};

export const deleteChangeLogs = async (): Promise<boolean> => {
  try {
    const response = await fetch(`/api/cms/delete-changelog-message`, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    const res = await response.json();
    if (!response.ok) throw new Error(res.errors?.[0]?.message || res.message || 'Failed to delete changelogs');
    toast.success('Semua changelog berhasil dihapus');
    return true;
  } catch (error: any) {
    toast.error(error.message || `Terjadi kesalahan ketika menghapus logs.`);
    return false;
  }
};

export const checkTokenValidity = async (): Promise<boolean> => {
  try {
    const uri = '/api/cms/is-token-valid';
    const response = await fetch(uri);
    const res = await response.json();
    if (!response.ok) throw new Error(res.message);
    return res.isTokenValid;
  } catch (error: any) {
    toast.error(errorMessage(error.response?.data || error) || `Terjadi kesalahan ketika mengecek token...`);
    return false;
  }
};

export const logOut = async (): Promise<boolean> => {
  try {
    const uri = '/api/cms/logout-cms';
    const response = await fetch(uri);
    const res = await response.json();
    if (!response.ok) throw new Error(res.message);

    return true;
  } catch (error: any) {
    toast.error(errorMessage(error.response?.data || error) || `Terjadi kesalahan ketika logout dari server...`);
    return false;
  }
};

export const fetchHomeData = async (): Promise<{ namaWeb: string }> => {
  try {
    const response = await fetch(`/api/cms/get-data-home`);
    const res = await response.json();
    return { namaWeb: res.namaWeb || '' };
  } catch (error) {
    console.error('Failed to fetch name:', error);
    return { namaWeb: '' };
  }
};
